import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProductState } from "../../types/Product";

const productSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    product: null,
    error: null,
    loading: false,
    uploadLoading: false,
    media: {},
    config: null,
    price: undefined,
    priceErrorMessage: null,
    total: 0,
    productTable: null,
    unitPrice: undefined,
    configLoading: false,
    priceErrorReason: null,
  } as ProductState,
  reducers: {
    getProductsAction: (state, action: PayloadAction<string[] | null>) => {
      state.products = [];
      state.total = 0;
      state.error = null;
    },
    getProductsSuccess: (state, action) => {
      state.products = action.payload.data || []; // Ensure it's an array
      state.total = action.payload.total || 0; // Set total products count
    },
    getProductsFailure: (state, action) => {
      state.error = action.payload;
    },
    getProductByIDAction: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    getProductByIDSuccess: (state, action) => {
      state.product = action.payload;
      state.loading = false;
    },
    getProductByIDFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    uploadFile: (state, action: PayloadAction<any>) => {
      state.uploadLoading = true;
      state.error = null;
    },
    uploadFileSuccess: (state, action: PayloadAction<any>) => {
      state.media = action.payload;
      state.uploadLoading = false;
      state.error = null;
    },
    uploadFileFailure: (state, action: PayloadAction<string>) => {
      state.uploadLoading = false;
      state.error = null;
    },
    getConfigAction: (state) => {
      state.error = null;
      state.config = null;
      state.configLoading = true;
    },
    getConfigSuccess: (state, action: PayloadAction<any>) => {
      state.config = action.payload;
      state.configLoading = false;
    },
    getConfigFailure: (state, action: PayloadAction<string>) => {
      state.config = null;
      state.error = null;
      state.configLoading = false;
    },
    clearFile: (state) => {
      state.media = {};
      state.error = null;
    },
    getPrice: (state, action: PayloadAction<any>) => {
      state.priceErrorMessage = null;
      state.priceErrorReason = null;
      state.unitPrice = undefined;
      state.productTable = null;
      state.price = undefined;
    },
    getPriceSuccess: (state, action: PayloadAction<any>) => {
      state.price = action.payload?.price;
      state.productTable = action.payload?.priceRangeTable;
      state.unitPrice = action.payload.unitPrice;
    },
    getPriceFailure: (
      state,
      action: PayloadAction<{ message: string; reason?: string }>,
    ) => {
      state.priceErrorMessage = action.payload?.message || "Failed to fetch price";
      state.priceErrorReason = action.payload?.reason || null;
    },
  },
});

export const {
  getProductsAction,
  getProductsSuccess,
  getProductsFailure,
  getProductByIDAction,
  getProductByIDSuccess,
  getProductByIDFailure,
  uploadFile,
  uploadFileSuccess,
  uploadFileFailure,
  clearFile,
  getConfigAction,
  getConfigSuccess,
  getConfigFailure,
  getPrice,
  getPriceSuccess,
  getPriceFailure,
} = productSlice.actions;

export default productSlice.reducer;
